import { render, staticRenderFns } from "./ConversationsListVirtual.vue?vue&type=template&id=50faa8f2"
import script from "./ConversationsListVirtual.vue?vue&type=script&lang=js"
export * from "./ConversationsListVirtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports